export default __webpack_public_path__ + "media/assets/images/ProgressiveHomeLogo-6fcad6fbb64a4f1e50dc64752b3ffa07.svg";